<template>
    <table>
        <tbody>
        <tr v-for="(preso, index) in presos" :key="preso.id">
            <td>{{ last+index+1 }}</td>
            <td><a :href="web_url+'presos/'+preso.slug">{{ preso.nombres }} {{ preso.apellidos }}</a></td>
        </tr>
        </tbody>
    </table>
</template>

<script>
import { web_url } from '../main.js';
export default {
    name: 'Preso Table',
    data() {
        return({web_url: web_url})
    },
    props: {
        presos: Object,
        last: Number
    }
}
</script>

<style scoped>
table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  max-width: 100%;
  background: transparent;
}

table > tbody > tr > td, 
table > tbody > tr > th, 
table > tfoot > tr > td, 
table > tfoot > tr > th, 
table > thead > tr > td, 
table > thead > tr > th {
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: top;
  border-top: 1px solid #ddd;
}

table tr:first-child td {
  border-top: 0px;
}

table tr:hover td {
  background: #eee;
}
</style>